import { useMemo } from 'react';

type ScopeContext = {
  type: 'scope';
  scopeType: string;
  parentContext?: PaletteContext | null;
};

type DeviceContext = {
  type: 'device';
  deviceName: string;
  parentContext?: PaletteContext | null;
};

type FlowContext = {
  type: 'flow';
  flowName: string;
  parentContext?: PaletteContext | null;
};

type AppContext = {
  type: 'app';
  appName: string;
  parentContext?: PaletteContext | null;
};

type SettingContext = {
  type: 'setting';
  settingTitle: string;
  parentContext?: PaletteContext | null;
};

type PaletteContext = ScopeContext | DeviceContext | FlowContext | AppContext | SettingContext;

function getContextLabel(context: PaletteContext): string {
  if (context.type === 'scope') {
    return context.scopeType;
  }

  if (context.type === 'device') {
    return context.deviceName;
  }

  if (context.type === 'flow') {
    return context.flowName;
  }

  if (context.type === 'app') {
    return context.appName;
  }

  return context.settingTitle;
}

export function useContextPath(activeContext: PaletteContext | null | undefined): string {
  return useMemo(() => {
    if (activeContext == null) {
      return '';
    }

    const labels: string[] = [];
    let cursor: PaletteContext | null | undefined = activeContext;

    while (cursor != null) {
      const label = getContextLabel(cursor);

      if (label) {
        labels.unshift(label);
      }

      cursor = cursor.parentContext;
    }

    return `${labels.join(' / ')} /`;
  }, [activeContext]);
}
